module.exports = __webpack_public_path__ + "static/img/4100_phase_function_Paper_Points.c6fc172.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4100_phase_function_Paper_Points.png
// module id = Ge+T
// module chunks = 0